// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__xdJXG","selects":"Documents_selects__3rzPg"};